const STORAGE_KEY = 'hria-last-login-email';

export function getLastLoginEmail(): string {
  try {
    return localStorage.getItem(STORAGE_KEY)?.trim() || '';
  } catch {
    return '';
  }
}

export function setLastLoginEmail(email: string): void {
  try {
    const trimmed = email.trim();
    if (trimmed) localStorage.setItem(STORAGE_KEY, trimmed);
  } catch {
    // ignore quota / private mode
  }
}
